// Stages of the delete confirmation. Not deleting is the absence of a flow, so
// there is no idle member.
export enum DeleteStep {
  WARNING = 'warning',
  KEYWORD = 'keyword',
}

// Steps of the create/edit user form, in tab order.
export enum UserFormStep {
  USER = 'user',
  GROUPS = 'groups',
  SECURITY = 'security',
  SUMMARY = 'summary',
}

// How long a new user keeps access. Mutually exclusive, so one value rather
// than a pair of flags.
export enum AccessDurationMode {
  SPECIFIC_DATE = 'specific_date',
  END_OF_SUBSCRIPTION = 'end_of_subscription',
}

// Dispatch ids for the User Management row ⋮ menu and header actions.
export enum UserAction {
  ADD_USER = 'add_user',
  EDIT_USER = 'edit_user',
  VIEW_USER_PROFILE = 'view_user_profile',
  DELETE_USER = 'delete_user',
}

export const USER_EMPTY_COPY = {
  NO_USERS: 'No users present.',
  LOAD_ERROR: 'Unable to load users. Please try again.',
};
